import { handleActions } from 'redux-actions'
import actions from '../actions'

const initialState = {
  snacks: [],
}

const reducer = handleActions(
  {
    [actions.snack.add]: (state, { payload }) => ({
      ...state,
      snacks: [...state.snacks, { ...payload, open: true }],
    }),
    [actions.snack.remove]: (state, { payload }) => ({
      ...state,
      snacks: state.snacks.filter((item) => item.id !== payload),
    }),
    [actions.snack.update]: (state, { payload }) => ({
      ...state,
      snacks: state.snacks.map((item) => (item.id !== payload.id ? item : payload)),
    }),
  },
  initialState,
)

export default reducer
